import { CommonModule, Location } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { WarehouseService } from '../../services/warehouse.service';
import { PaginationComponent } from '../../common/pagination/pagination.component';
import { FormsModule } from '@angular/forms';
import { ImplantsModalComponent } from 'src/app/shared/implants-modal/implants-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { ImplantDetailModalComponent } from '../modals/implant-detail-modal/implant-detail-modal.component';
import { AddImplantModalComponent } from '../modals/add-implant-modal/add-implant-modal.component';

@Component({
  selector: 'app-implants-list',
  standalone: true,
  imports: [
    CommonModule,
    PaginationComponent, 
    FormsModule, 
    RouterLink
  ],
  templateUrl: './implants-list.component.html',
  styleUrls: ['./implants-list.component.scss', '../../../app.component.scss']
})
export class ImplantsListComponent {

  @ViewChild(PaginationComponent) paginationView: PaginationComponent;

  public warehouseId = "";
  public warehouseDetails: any;

  public implantType = "";

  public implantProducts: any = [];
  public isImplantProducts: boolean = false;

  public totalPages: number = 0;
  public currentPage: number = 1;
  
  public totalImplants: number = 0;

  public searchInput: string = "";
  public encodedSearchInput: string = "";


  public isSearch = false;
  public isFilter = false;
  public isFilterResult = true;
  
  public expirySortValue:string = "";
  public orderBy:string = "asc";

  constructor(public warehouseService: WarehouseService, public dialog: MatDialog, public location: Location, public route: ActivatedRoute){

  }

  ngOnInit(): void {
    this.route.params.subscribe(routeParams => {
      this.warehouseId = routeParams.id;
      this.implantType = routeParams.type;
      
      this.getWarehouseDetails();
      this.getImplants();
    });
    
  }

  getImplants(page: string = "", search: string = "", expiry: string = ""){
    this.warehouseService.getImplants(this.warehouseId, this.implantType, page, search, expiry).subscribe(res => {
      if (res.data) {
        if (res.data.data.length !== 0) {
          this.totalImplants = res.data.total;
          this.totalPages = res.data.last_page;
          this.implantProducts = res.data.data;

          if (this.isSearch || this.isFilter) {
            this.isFilterResult = true;
          }else{
            this.isImplantProducts = true;
          }
        }else{
          this.totalImplants = 0;
          this.totalPages = 0;
          if (this.isSearch || this.isFilter) {
            this.isFilterResult = false;
          }else{
            this.isImplantProducts = false;
          }
        }
      }
    });
  }

  getWarehouseDetails(){
    this.warehouseService.getWarehouseDetails(this.warehouseId).subscribe((res)=>{
      if (res.data) {
        this.warehouseDetails = res.data;
      }
    });
  }

  onSearchSubmit(){
    if (this.searchInput !== "") {
      this.isSearch = true;
      if (this.isFilter) {
        this.expirySortValue = "";
        this.isFilter = false;
        this.isFilterResult = true;
      }
      this.encodedSearchInput = encodeURIComponent(this.searchInput);
      if (this.currentPage > 1) {
        this.currentPage = 1;
        this.paginationView.onCurrentPageChange(this.currentPage);
      }
      this.getImplants("", this.encodedSearchInput);
    }
  }

  expirySort(){
    this.isFilter = true;

    if (this.expirySortValue === "asc") {
      this.expirySortValue = "desc";
    }else{
      this.expirySortValue = this.orderBy;
    }

    this.onFilterChange();   
  }

  reset(event: Event){
    event.preventDefault();
    if (this.isSearch || this.isFilter) {
      this.encodedSearchInput = "";
      this.expirySortValue = "";
      this.isSearch = false;
      this.isFilter = false;
      this.isFilterResult = true;
      if (this.currentPage > 1) {
        this.currentPage = 1;
        this.paginationView.onCurrentPageChange(this.currentPage);
      }
      this.getImplants("");
    }
  }

  onFilterChange(){
    if (this.currentPage > 1) {
      this.currentPage = 1;
      this.paginationView.onCurrentPageChange(this.currentPage);
    }
    
    this.getImplants("", this.encodedSearchInput, this.expirySortValue);
  }

  getQueryPage($event: number){
    this.currentPage = $event;    
    this.getImplants(`${this.currentPage}`, this.encodedSearchInput, this.expirySortValue);
  }

  openDialog(storeId: string, implantId: string, implantType: string): void {
    const dialogRef = this.dialog.open(ImplantDetailModalComponent, {
      data: {
        storeId,
        implantId, 
        implantType 
      }
    });

    dialogRef.afterClosed().subscribe(result => {});
  }

  openAddProductDialog(warehouseId: string){
    const dialogRef = this.dialog.open(AddImplantModalComponent, {
      data: {
        warehouseId
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getImplants();
      }
    });
  }

  goBack(){
    this.location.back();
  }
}
